import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedDate } from 'components/intl'
import { Modal, ModalCTA } from 'containers/misc'
import { Span, Title } from 'components/layout'
import { Input, InputDate } from 'components/fields'
import { Button, ButtonGroup, List, ListItem, Module } from 'components/misc'
import { modal } from 'redux/modules/app'
import { apiLeaders } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import { trainingValidate } from 'models/leaders'
import { FormattedHTMLMessage } from 'react-intl'
import { RichTextArea } from '../../../../components/richtext'
import styles from './leader-trainings.styl'

@apiLeaders({
  updateDetail: true,
  detailReadParams: 'AWARD_LEADERSHIP_HISTORY,TRAININGS',
  personReadParams: 'ADDRESS,AWARD_LEADER_PROFILE,AWARD_LEADERSHIP_HISTORY'
})
@connect(null, { modal })
@form({
  form: 'add-leader-traning',
  validate: trainingValidate
})
export default class LeaderTraining extends Component {
  static propTypes = {
    first: PropTypes.bool,
    modal: PropTypes.func.isRequired,
    leaderId: PropTypes.number,
    addTraining: PropTypes.func.isRequired,
    updateTraining: PropTypes.func.isRequired,
    deleteTraining: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    list: PropTypes.array,
    submitting: PropTypes.bool
  }

  static defaultProps = {
    list: []
  }

  state = {
    isEditing: false,
    isDeleting: false,
    id: null,
    trainingName: ""
  }

  handleAddTraining = () => {
    this.props.modal('modal-leader-training')
    this.props.initialize({})
  }

  handleEditTraining = training => {
    this.props.modal('modal-leader-training')
    this.props.initialize({
      id: training.id,
      trainingName: training.translatedTrainingName,
      trainingDate: training.trainingDate
    })
    this.setState({
      isEditing: true,
      id: training.id,
      trainingName: training.translatedTrainingName
    })
  }

  handleDeleteTraining = () => {
    this.setState({
      isDeleting: true
    })
  }

  handleOnClose = () => {
    this.setState({
      isEditing: false,
      isDeleting: false,
      id: null
    })
  }

  handleCancelDelete = () => {
    this.setState({
      isDeleting: false
    })
  }

  render () {
    const {
      handleSubmit,
      addTraining,
      updateTraining,
      deleteTraining,
      submitting,
      leaderId,
      first,
      list
    } = this.props
    const { isEditing, isDeleting, id } = this.state

    const buttonDefinition = [
      {
        'order': 1,
        'secondary': true,
        'onClick': this.handleAddTraining,
        'iconAction': null,
        'isActionLoading': false,
        'intlKeyAction': 'button.add_training',
        'action': 'Add training'
      }
    ]

    return (
      <div>
        <Module
          title="Training"
          intlKey="moduleTitle.training"
          buttonDefinition={buttonDefinition}
          primary
          first={first}
        >
          <List custom>
            <div>
              {list.map(item => (
                <ListItem
                  key={item.id}
                  onClick={() => this.handleEditTraining(item)}
                >
                  <div className="row">
                    <div className="col-xs-6">
                      <FormattedHTMLMessage
                        id="label.translatedTrainingName"
                        defaultMessage= {item.translatedTrainingName}
                      />
                    </div>
                    <div className="col-xs-6 text--right">
                      {item.trainingDate && (
                        <FormattedDate value={item.trainingDate} />
                      )}
                    </div>
                  </div>
                </ListItem>
              ))}
              {list.length === 0 && (
                <Span intlKey="global.no_records" muted>
                  No records
                </Span>
              )}
            </div>
          </List>
        </Module>
        <Modal
          id="modal-leader-training"
          action="Add"
          intlKey="button.add"
          onClose={this.handleOnClose}
          customActions
          enableOverflow
        >
          <form
            onSubmit={handleSubmit(
              fields =>
                isEditing
                  ? updateTraining(fields, leaderId)
                  : addTraining(fields, leaderId)
            )}
          >
            <div className="row">
              <div className={styles.block}>
                <RichTextArea label="Text"  intlKey="label.training_name" name="trainingName" isInitialized={true}/>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-6">
                <InputDate
                  label="Date"
                  intlKey="label.date"
                  name="trainingDate"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-6">
                <ButtonGroup>
                  <Button
                    type="button"
                    intlKey="button.close"
                    onClick={() => this.props.modal(null)}
                    secondary
                  >
                    Close
                  </Button>
                  {isEditing && (
                    <Button
                      type="button"
                      intlKey="button.delete"
                      onClick={() => this.handleDeleteTraining(id)}
                      negative
                    >
                      Delete
                    </Button>
                  )}
                </ButtonGroup>
              </div>
              <div className="col-xs-6 text--right">
                {!isEditing ? (
                  <Button intlKey="button.add" isLoading={submitting}>
                    Add
                  </Button>
                ) : (
                  <Button intlKey="button.save" isLoading={submitting}>
                    Save
                  </Button>
                )}
              </div>
            </div>
          </form>
          {isDeleting && (
            <ModalCTA>
              <Title
                h2
                className="text--center"
                intlKey="moduleTitle.would_you_like_to_remove_leader_training"
              >
                Would you like to delete Award Leaders's training?
              </Title>
              <div className="row">
                <div className="col-xs-6">
                  <Button
                    type="button"
                    onClick={this.handleCancelDelete}
                    secondary
                    intlKey="button.close"
                  >
                    Close
                  </Button>
                </div>
                <div className="col-xs-6 text--right">
                  <Button
                    type="button"
                    negative
                    intlKey="button.confirm"
                    onClick={() => deleteTraining(id, leaderId)}
                  >
                    Confirm
                  </Button>
                </div>
              </div>
            </ModalCTA>
          )}
        </Modal>
      </div>
    )
  }
}
